import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as conversations from '../../conversations'

export const RESOURCE = {
  payload: {
    description:
      'A single message within a conversation, carrying its role and status.',
    dimension: conversations.RESOURCE.payload,
    level: 1,
    name: 'Message',
    partialId: PartialId.Standard.create('message'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
